import { trackElementClicked } from '@/features/shared/analytics/element'
import { MEMBER_APP_DOWNLOAD_URL, SHOPPER_APP_DOWNLOAD_URL } from '@/features/shared/constants/urls'
import { Stack } from '@shipt/design-system-layouts'
import { AppStoresIcon } from '@shipt/design-system-icons'
import { getLinkNewTabAttributes } from '@/features/shared/elements/Link/utils'
import { useIsPage } from '@/features/shared/hooks/useIsPage'
import { useSearchParams } from 'next/navigation'
import { useAppendBranchDeepLinkParams } from '@/lib/branch/utils'

type Props = {
  className?: string
  isShopper: boolean
  openInNewTab: boolean
  displaySublocation?: string
}

export const AppBadges = ({ className, openInNewTab, isShopper, displaySublocation }: Props) => {
  const { TARGET_CIRCLE_360: isC360LP } = useIsPage()
  const searchParams = useSearchParams()

  const baseUrl = isShopper ? SHOPPER_APP_DOWNLOAD_URL : MEMBER_APP_DOWNLOAD_URL

  let urlWithParams = baseUrl

  if (!isShopper && isC360LP) {
    const queryParams = new URLSearchParams(searchParams?.toString())
    queryParams.append('action', 'target-circle-360')

    if (searchParams?.get('store_id')) {
      queryParams.append('destination', 'home')
    }

    urlWithParams = `${baseUrl}?${queryParams}`
  }

  const appDownloadLink = useAppendBranchDeepLinkParams(urlWithParams)

  const handleOnClick = (content: 'google' | 'apple') => {
    trackElementClicked({
      type: 'button',
      content,
      display_sublocation: displaySublocation,
    })
  }
  const linkAttributes = getLinkNewTabAttributes(openInNewTab)

  return (
    <Stack spacing="lg" className={className}>
      <a
        href={appDownloadLink}
        aria-label="Shipt App in Apple App Store"
        onClick={() => handleOnClick('apple')}
        {...linkAttributes}
      >
        <AppStoresIcon variant="apple" />
      </a>
      <a
        href={appDownloadLink}
        aria-label="Shipt App in Google Play"
        onClick={() => handleOnClick('google')}
        {...linkAttributes}
      >
        <AppStoresIcon variant="google" />
      </a>
    </Stack>
  )
}
